<script setup lang="ts">
import AdminLayout from './admin.vue'
</script>

<template>
  <AdminLayout>
    <slot />
  </AdminLayout>
</template>
